import { useStaticQuery } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";
import { getMapping } from "../utils/mapping";
export var useHomePageFAQ = function useHomePageFAQ() {
    var _useI18next = useI18next(), language = _useI18next.language;
    var languageMap = getMapping("lang");
    var mappedLanguage = languageMap[language];
    var data = useStaticQuery("961794348"); // Filter data by language after query
    var filteredData = data.allContentfulAccordionsComponent.edges.map(function (edge) { return edge.node; }).filter(function (node) { return node.node_locale === mappedLanguage; });
    return filteredData;
};
